import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-comment',
  templateUrl: './create-comment.component.html',
  styleUrls: ['./create-comment.component.scss']
})
export class CreateCommentComponent implements OnInit {
  @Input() componentInfo: any;
  fileImg64: any;
  wrongSize: any;
  commentForm: FormGroup;
  maxLength = 350;

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  sendData(): any {
    const dataToSend = {
      ...this.commentForm.value,
      typeId: this.componentInfo.reference,
    };

    this.activeModal.close(dataToSend);
  }

  private createForm(): any {
    this.commentForm = this.fb.group({
      title: ['', Validators.required],
      comment: ['', Validators.required],
      img: ['', Validators.required],
      img64: ['', Validators.required],
      subTitle: ['', Validators.required],
      codeImg: [1],
    });
  }

  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (image.width <= 50 && image.height <= 50) {
          this.wrongSize = null;
          this.fileImg64 = image.src;
          this.commentForm.get('img').setValue((event.target.files[0]).name);
          this.commentForm.get('img64').setValue(this.fileImg64.split(',')[1]);
        } else {
          this.wrongSize = 'Resolución de imagen no permitida (requerida: 50px x 50px)';
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }


}
